import enquire from 'enquire.js/dist/enquire.min';

// c-submenu > dropdown
enquire.register('screen and (max-width: 767px)', {
    match: function () {
        $('.c-submenu .c-submenu__list').css('display', 'none');
        $('.c-submenu .c-submenu__dropdown').css('display', 'flex');
        $('.c-submenu .c-submenu__dropdown').click(function () {
            $('.c-submenu .c-submenu__list').toggle();
            $('.c-submenu .c-submenu__dropdown').toggleClass('js-open');
        });
        $('.c-submenu__list-item').click(function () {
            $('.c-submenu .c-submenu__dropdown').removeClass('js-open');
            $('.c-submenu .c-submenu__list').css('display', 'none');
        });
    },
    unmatch: function () {
        $('.c-submenu .c-submenu__list').css('display', 'inline-flex');
        $('.c-submenu .c-submenu__dropdown').css('display', 'none');
    },
});



// WEBPACK FOOTER //
// ./scripts/routes/components/submenu.js